import { Button, SelectDropDown, TextField } from '@/components/Common';
import { TextfieldType } from '@/components/Common/TextField/TextField.types';
import { Modal } from '@/components/Layout';
import { AlertModal } from '@/components/Layout/AlertModal/AlertModal';
import { ModalPositions } from '@/components/Layout/Modal/Modal.types';
import { TextEditor } from '@/components/Ui';
import { useEffect } from 'react';
import { Controller } from 'react-hook-form';
import { useFaqList } from './FaqList.hook';
export const FaqForm = () => {
  const {
    isOpenForm,
    registerFaq,
    errorsFaq,
    handleDraftFaq,
    handleDraftUpdateFaq,
    handleCreateAndPublishFaq,
    setValueFaq,
    handleChangeCategory,
    faqCategories,
    control,
    isEditMode,
    faq,
    setSelectedFaqByCategory,
    handleCloseForm,
    isCreatePublishModalOpen,
    setIsCreatePublishModalOpen,
    handleConfirmCreateAndPublish,
    isCreatingFaq,
    getPublishButtonText,
    getModalTitle,
    getModalMessage,
  } = useFaqList();

  useEffect(() => {
    if (faq && isEditMode) {
      setValueFaq('question', faq?.question);
      setValueFaq('answer', faq?.answer);
      setValueFaq('category', faq?.category?._id);
      handleChangeCategory({
        _id: faq?.category?._id,
        name: faq?.category?.name,
      });
      setSelectedFaqByCategory(faq);
    }
  }, [faq, isEditMode, setValueFaq]);

  return (
    <Modal
      isOpen={isOpenForm}
      onClose={handleCloseForm}
      position={ModalPositions.RIGHT}
      modalStyle="p-0"
      headerStyle="bg-black"
    >
      <div className="h-[90vh] w-[70vw] bg-black relative">
        <form className={`grid grid-cols-[33%_auto] items-start`}>
          <div className="flex flex-col gap-4 h-[85vh] overflow-auto py-4 px-8">
            <h3 className="text-[30px] font-raleway font-bold leading-[49.32px] text-white text-center">
              {isEditMode ? 'Modifier la question' : 'Ajouter une question'}
            </h3>
            <ul className="flex flex-col gap-8 pt-4 relative h-full">
              <li className="grid grid-cols-[15%_auto] gap-4">
                <div className="flex items-center justify-center h-[48px] w-[48px] rounded-full bg-[#1D1D1D]">
                  <i className="pi pi-file text-[#939393] text-xl"></i>
                </div>
                <TextField
                  inputStyle={{ background: '#1D1D1D' }}
                  placeholder={'Intitulé de la question'}
                  name="question"
                  register={registerFaq('question')}
                  textFieldType={TextfieldType.INPUT}
                  errorStyle="text-red-500"
                  helpText={errorsFaq?.question?.message}
                />
              </li>
              <li className="grid grid-cols-[15%_auto] gap-4">
                <div className="flex items-center justify-center h-[48px] w-[48px] rounded-full bg-[#1D1D1D]">
                  <i className="pi pi-graduation-cap text-[#939393] text-xl"></i>
                </div>
                <SelectDropDown
                  selectDropDownStyle={{
                    borderRadius: '0.375rem',
                    color: '#fff',
                    padding: ' 0.5rem',
                  }}
                  placeholder="Catégorie"
                  name="category"
                  errorStyle="text-red-500"
                  helpText={errorsFaq?.category?.message}
                  options={faqCategories || []}
                  setValue={setValueFaq}
                  initialSelectedOptions={isEditMode ? faq?.category : null}
                  handleChange={handleChangeCategory}
                />
              </li>
              <div className="absolute bottom-8 left-0 right-0 flex flex-col gap-2">
                <Button
                  onClick={isEditMode ? handleDraftUpdateFaq : handleDraftFaq}
                  title={'Enregistrer brouillon'}
                  className="bg-white text-black mb-4"
                  type="submit"
                />
                <Button
                  type="button"
                  onClick={handleCreateAndPublishFaq}
                  className="bg-[#FEC200] text-black"
                  title={getPublishButtonText()}
                />
              </div>
            </ul>
          </div>
          <div className="flex flex-col gap-6 p-4 h-[85vh] overflow-auto py-4 px-8">
            <Controller
              name="answer"
              control={control}
              render={({ field }) => (
                <TextEditor
                  backgroundColor="#000"
                  onChange={field.onChange}
                  initialValue={isEditMode ? faq?.answer : ''}
                />
              )}
            />
            {errorsFaq?.answer && (
              <span className="text-red-500 text-xs mt-2">
                {errorsFaq?.answer?.message}
              </span>
            )}
          </div>
        </form>
        <AlertModal
          isOpen={isCreatePublishModalOpen}
          onClose={() => setIsCreatePublishModalOpen(false)}
          title={getModalTitle()}
          message={getModalMessage()}
          buttonTitle={isCreatingFaq ? 'En cours...' : getPublishButtonText()}
          buttonCancelTitle="Annuler"
          handleConfirm={handleConfirmCreateAndPublish}
        />
      </div>
    </Modal>
  );
};
